const INITIAL_STATE = {
  data: {},
  errors: {},
};
  
const GetSchedulingErrors = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case "GET_SCHEDULING_ERRORS_LIST":
    return { ...INITIAL_STATE, data: action.data };
  case "GET_SCHEDULING_ERRORS_LIST_FAILED":
    return { ...INITIAL_STATE, errors: action.data };
  default:
    return { ...state };
  }
};
  
export default GetSchedulingErrors;
  